import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { BUYER_CITIES, BUYER_NAMES } from '../data/content';
function randomBuyer() {
  const name = BUYER_NAMES[Math.floor(Math.random() * BUYER_NAMES.length)];
  const city = BUYER_CITIES[Math.floor(Math.random() * BUYER_CITIES.length)];
  const mins = Math.floor(Math.random() * 14) + 1;
  return {
    name,
    city,
    mins
  };
}
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<ReturnType<typeof randomBuyer> | null>(null);
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setBuyer(randomBuyer());
      hideTimeout = setTimeout(() => setBuyer(null), 5000);
      timeout = setTimeout(cycle, 5000 + Math.random() * 7000 + 3000);
    };
    const initial = setTimeout(cycle, 4000);
    return () => {
      clearTimeout(initial);
      clearTimeout(timeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-141">
      {buyer && <motion.div initial={{
      opacity: 0,
      y: 24,
      x: -8
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.35
    }} className="fixed bottom-4 left-3 right-3 z-40 mx-auto max-w-sm sm:left-4 sm:right-auto" role="status" data-id="element-142">
          <div className="flex items-center gap-3 rounded-2xl border border-[var(--pb-lime)]/30 bg-[#141d30] px-4 py-3 shadow-2xl shadow-black/50" data-id="element-143">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--pb-lime)]/15 text-[var(--pb-lime)]" data-id="element-144">
              <CheckCircle2Icon size={22} data-id="element-145" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-146">
              <p className="text-sm font-700 leading-tight text-white" data-id="element-147">
                {buyer.name} from {buyer.city}
              </p>
              <p className="truncate text-xs text-white/60" data-id="element-148">
                just purchased the Pickleball Coach 360 Kit · {buyer.mins} min
                ago
              </p>
            </div>
            <button type="button" onClick={() => setBuyer(null)} aria-label="Close notification" className="shrink-0 text-white/40 hover:text-white/80" data-id="element-149">
              <XIcon size={18} data-id="element-150" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}